import React from 'react';
import cn from './style.module.scss';
export default function ArtHeadBlock({ children }: any) {
  return <div className={cn.headerLayout}> {children}</div>;
}
